export default __webpack_public_path__ + "static/media/tappet-mobile-logo.b8f621fd.jpg";